export default __webpack_public_path__ + "static/media/horizontal-cell-lines.1f6e99be.jpeg";